import obtenerHistorialSinConcesion from "./obtenerSinConcesion";
import agruparArray from "../../historial/agruparArray";

/**
 * Actualiza el historial de ordenes de pago después de generar una nueva póliza
 * @param {Number} idConcesion 
 * @param {Object} data 
 * @param {Function} setData 
 */
export default async function actualizarHistorialSinConcesiones(data, setData) {
    const idContribuyente = data.contribuyente.idContribuyente;
    const dataHistorial = await obtenerHistorialSinConcesion(idContribuyente);
    setData({ ...data, historial: [...dataHistorial], historialArray: [...agruparArray(dataHistorial, 10)] });
}